@if (inline) {
  <div class="inline-discount">
    <div class="inline-discount-header">
      <i class="ico-ticket" aria-hidden="true"></i>
      <span class="inline-discount-label" i18n="@@railcardsApplied">Applied discount/card</span>
    </div>
    @for (card of cards; track card) {
      <span class="inline-discount-value">
        @if (type === ServiceProvider.Trainline) {
          @if (card.type === DiscountType.RailCard) {
            {{ card.count }} x {{ card.description }}
          }
          @if (card.type === DiscountType.DiscountCard) {
            {{ card.description }}
          }
          @if (card.type === DiscountType.Groupsave) {
            GroupSave Discount
          }
        } @else {
          {{ card.count }} x {{ card.description }}
        }
      </span>
    }
  </div>
} @else {
  <div class="wrapper" [class.lightMode]="isScion">
    <mat-expansion-panel class="rail_item" id="rail-journey">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="visuallyhidden" i18n="@@searchToggleState_show">Show</span>
          <i class="ico-ticket" aria-hidden="true"></i> &nbsp;
          <span i18n="@@railcardsApplied">Applied discount/card</span>
          @if (basketItem.detail; as detail) {
            <span class="visuallyhidden">
              for {{ detail.outwardDetail.departureStationName }} to
              {{ detail.outwardDetail.arrivalStationName }}
            </span>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (card of cards; track card) {
        <div class="summary">
          @if (type === ServiceProvider.Trainline) {
            <div>
              @if (card.type === DiscountType.RailCard) {
                <div>{{ card.count }} x {{ card.description }}</div>
              }
              @if (card.type === DiscountType.DiscountCard) {
                <div>{{ card.description }}</div>
              }
              @if (card.type === DiscountType.Groupsave) {
                <div>GroupSave Discount</div>
              }
            </div>
          } @else {
            {{ card.count }} x {{ card.description }}
          }
        </div>
      }
    </mat-expansion-panel>
  </div>
}
